// usePodeAvaliar.js — "esta pessoa pode avaliar este livro?"
//
// POR QUE ISTO É NECESSÁRIO:
// desde 19/08/2026 só quem comprou o livro pode avaliá-lo. Sem consultar antes,
// a página mostraria o formulário para todo mundo e o 403 chegaria DEPOIS de a
// pessoa escrever o comentário inteiro — o pior momento possível para descobrir
// que não podia.
//
// GET {API}ebook/{id}/posso-avaliar  (Bearer)
//   → { pode, motivo: "ok"|"nao_comprou"|"nao_logado", ja_avaliou, avaliacao, coins_por_avaliacao }
//
// Sem token nem chama o backend: a resposta já é conhecida.
import { useState, useEffect, useCallback } from "react";
import { COINS_POR_AVALIACAO } from "../config/coins";

const API_URL = process.env.REACT_APP_API;

const pegarToken = () =>
  localStorage.getItem("token" + (process.env.REACT_APP_USER_FUNCTION || ""));

const usePodeAvaliar = (ebookId) => {
  const [estado, setEstado] = useState({
    pode: false,
    motivo: "nao_logado",
    jaAvaliou: false,
    avaliacao: null,
    coins: COINS_POR_AVALIACAO,
    loading: true,
  });

  const carregar = useCallback(async () => {
    if (!ebookId) return;

    const token = pegarToken();
    if (!token) {
      setEstado((e) => ({ ...e, pode: false, motivo: "nao_logado", loading: false }));
      return;
    }

    setEstado((e) => ({ ...e, loading: true }));
    try {
      const resp = await fetch(`${API_URL}ebook/${ebookId}/posso-avaliar`, {
        headers: { Accept: "application/json", Authorization: "Bearer " + token },
      });
      if (!resp.ok) throw new Error("sem resposta");
      const d = await resp.json();
      setEstado({
        pode: !!d.pode,
        motivo: d.motivo || "nao_comprou",
        jaAvaliou: !!d.ja_avaliou,
        avaliacao: d.avaliacao || null,
        coins: Number(d.coins_por_avaliacao) || COINS_POR_AVALIACAO,
        // Para o motivo "leitura_insuficiente" (assinante do Clube que ainda
        // não leu o mínimo): a tela diz quanto falta, em vez de mandar comprar.
        percentualLido: Number(d.percentual_lido) || 0,
        percentualMinimo: Number(d.percentual_minimo) || 0,
        loading: false,
      });
    } catch {
      // Rede fora ou sessão expirada: trata como "não pode", que é o estado
      // seguro — o contrário mostraria um formulário que o servidor recusaria.
      setEstado((e) => ({ ...e, pode: false, motivo: "nao_logado", loading: false }));
    }
  }, [ebookId]);

  useEffect(() => {
    carregar();
  }, [carregar]);

  return { ...estado, recarregar: carregar };
};

export default usePodeAvaliar;
